/**
 * The photo gallery's bubbles, as the app's `PageViewDotIndicator` (`hintsHiddenPages`):
 * at most `max` dots around the photo on show. The active one is a 24px pill that follows
 * the swipe (`position` is fractional mid-swipe); a dot at the edge of the window shrinks
 * when more photos lie beyond it.
 */
export function heroDots(
  count: number,
  position: number,
  max = 7,
): { index: number; width: number; scale: number }[] {
  if (count <= 1) return [];
  const shown = Math.min(count, max);
  const start = Math.min(
    Math.max(Math.round(position) - Math.floor(shown / 2), 0),
    count - shown,
  );
  const end = start + shown - 1;
  return Array.from({ length: shown }, (_, offset) => {
    const index = start + offset;
    const nearness = Math.max(0, 1 - Math.abs(position - index));
    const hidesMore =
      (index === start && start > 0) || (index === end && end < count - 1);
    return { index, width: 8 + 16 * nearness, scale: hidesMore ? 0.5 : 1 };
  });
}
